import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { jobList, jobPaymentDetails } from "constants/job";
import { customerLocation } from "constants/customer";
import { WORK_ORDER } from "components/Common/constants";

export const getJobList = async (
  dispatch,
  { pageNum, filters, searchString } = {},
) => {
  try {
    const res = await api.job_list(pageNum, filters, searchString);
    dispatch({ type: jobList, payload: res.data });
    return res.data;
  } catch (error) {
    const errorData = error?.response?.data || error;
    dispatch({ type: jobList, payload: errorData });
    authorizedUser(error.response?.data);
    return errorData;
  }
};

// add job
export const addJob = async (bodyData) => {
  try {
    const res = await api.add_job(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//get customer location and return

export const getCustomerLocation = async (
  dispatch,
  customerID,
  pageNum = null,
  filters = {},
) => {
  try {
    const res = await api.customer_location_list(customerID, pageNum, filters);

    dispatch({ type: customerLocation, payload: res.data });
    return res.data;
  } catch (error) {
    dispatch({
      type: customerLocation,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

//get user detail by id
export const getJobByID = async (id) => {
  try {
    const res = await api.get_job_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// get job time line by id
export const getJobTimeLineByID = async (id) => {
  try {
    const res = await api.job_time_line_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//post job files
export const uploadJobFilesByID = async (id, formData) => {
  try {
    const res = await api.job_upload_files_by_ID(id, formData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

// get job logs by id
export const getJobLogsByID = async (id) => {
  try {
    const res = await api.job_logs_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Technical Report
export const addTechnicalReport = async (bodyData) => {
  try {
    const res = await api.add_technical_report(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
export const getTechnicalReportByID = async (id) => {
  try {
    const res = await api.technical_report_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// get feedback by id
export const getFeedbackByID = async (jobID) => {
  try {
    const res = await api.get_feedback_by_ID(jobID);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Cancel Job By Job id
export const cancelJobByJobId = async (jobId, body) => {
  try {
    const res = await api.cancel_job(jobId, body);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Complete Job By Job id
export const completeJobByJobID = async (jobId, body) => {
  try {
    const res = await api.complete_job(jobId, body);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Job Media
export const getJobMediaByJobID = async (jobId) => {
  try {
    const res = await api.jobMedia(jobId);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Complete or Rework Job

export const updateJobStatus = async (jobId, bodyData) => {
  try {
    const res = await api.jobCompletedOrRework(jobId, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Download Job Report
export const downloadJobReportByJobId = async (jobId) => {
  try {
    const res = await api.downloadJobReport(jobId);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      try {
        const parsed = JSON.parse(text);
        return {
          status: error.response.status,
          code: parsed.code,
          message: parsed.message,
        };
      } catch {
        return {
          status: error.response.status,
          code: 500,
          message: `Failed to download ${WORK_ORDER} report. Please try again.`,
        };
      }
    }

    return {
      status: 500,
      code: 500,
      message:
        error.message || `Failed to download ${WORK_ORDER} report. Please try again.`,
    };
  }
};

export const updateJobToContinue = async (jobId, bodyData) => {
  try {
    const res = await api.contiueJob(jobId, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Mark job as under warrenty
export const markJobUnderWarrenty = async (jobID, bodyData) => {
  try {
    const res = await api.jobUnderWarrenty(jobID, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Admin Note
export const updateAdminNote = async (jobID, bodyData) => {
  try {
    const res = await api.adminNote(jobID, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// edit sales order number
export const updateSalesOrderNumber = async (jobID, bodyData) => {
  try {
    const res = await api.edit_sales_order_number(jobID, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const downloadJobMedia = async (jobMediaID, technicalReportID = 0) => {
  try {
    const res = await api.download_job_media(jobMediaID, technicalReportID);
    return res;
  } catch (error) {
    if (error.response && error.response.data instanceof Blob) {
      const text = await error.response.data.text();
      const json = JSON.parse(text);
      return json;
    }

    return (
      error.response?.data || {
        code: 500,
        status: "FAILED",
        message: `Failed to download ${WORK_ORDER} media. Please try again.`,
      }
    );
  }
};

export const editTechnicalReport = async (id, bodyData) => {
  try {
    const res = await api.edit_technical_report(id, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteTechnicalReportMedia = async (mediaId, technicalReportID) => {
  try {
    const res = await api.delete_technical_report_media(mediaId, technicalReportID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const recordBankTransfer = async (jobID, bodyData) => {
  try {
    const res = await api.record_bank_transfer(jobID, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getPaymentDetails = async (dispatch, jobID) => {
  try {
    const res = await api.payment_details(jobID);
    dispatch({ type: jobPaymentDetails, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({ type: jobPaymentDetails, payload: error?.response?.data || error });
  }
}

export const reopenJob = async (jobID) => {
  try {
    const res = await api.reopen_job(jobID);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const updateInternalMonitoring = async (jobID, trackingFlag) => {
  try {
    const res = await api.internal_monitoring(jobID, trackingFlag);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
}

export const exportJobsCSV = async ({ filters, searchString } = {}) => {
  try {
    const res = await api.export_jobs(filters, searchString);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};


//get user detail by id
// export const downloadBulkWorkOrderReport = async (bodyData) => {
//   try {
//     const res = await api.download_bulk_work_order_report(bodyData);
//     return res;
//   } catch (error) {
//     return error?.response?.data || error;
//   }
// };

// Download Bulk Job Reports

export const downloadBulkWorkOrderReport = async (bodyData) => {
  try {
    const res = await api.download_bulk_job_reports(bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const downloadBulkWorkOrderReportList = async () => {
  try {
    const res = await api.download_bulk_job_reports_list();
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Download Work Order Quotation Items CSV
export const downloadWorkOrderQuotationItemsCSV = async (jobIds, all = "NO") => {
  try {
    console.log(jobIds,"jobIdsjobIdsjobIdsjobIds")
    const res = await api.download_job_quotation_items_csv(jobIds, all);
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const downloadBulkWorkOrderReportsStatus = async (exportID) => {
  try {
    const res = await api.download_bulk_job_reports_status(exportID);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const downloadBulkWorkOrderReportsdownloadByBrowser = async (exportID) => {
  try {
    const res = await api.download_bulk_job_reports_through_browser(exportID);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
export const bulkWorkOrder = async (jobIDs) =>{
   try {
    const res = await api.bulk_report(jobIDs);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}
